import { fmtDate, fmtDateCompact } from '@/lib/format';
import { useI18n } from '@/providers/i18n';
import type { Lineup, Venue } from '@/types';

import styles from './EventDossier.module.css';

interface EventDossierProps {
  event: {
    date: string;
    dateEnd?: string;
    doors?: string;
    close?: string;
    lineup?: Lineup;
  };
  venue: Venue;
  archived?: boolean;
}

export default function EventDossier({ event, venue, archived = false }: EventDossierProps) {
  const { t, lang } = useI18n();
  const dd = fmtDate(event.date, lang);
  const stageKeys = event.lineup ? Object.keys(event.lineup) : [];
  const stages = stageKeys.length;

  return (
    <section className={styles.root}>
      <header className={styles.sectionH}>
        <span className={styles.headNum}>/ 01</span>
        <span className={styles.headTtl}>EVENT DETAILS</span>
        <span className={styles.headMeta}>{venue.name}</span>
      </header>
      <dl className={styles.info}>
        <div className={`${styles.row} ${styles.big}`}>
          <dt>{t('label.date')}</dt>
          <dd>
            {dd.day} {dd.month} {dd.year}
            {event.dateEnd ? ` → ${fmtDateCompact(event.dateEnd)}` : ''}
          </dd>
        </div>
        <div className={`${styles.row} ${styles.big}`}>
          <dt>{t('label.venue')}</dt>
          <dd>{venue.name}</dd>
        </div>
        {event.doors ? (
          <div className={styles.row}>
            <dt>{t('label.doors')}</dt>
            <dd>{event.doors}</dd>
          </div>
        ) : null}
        {event.close ? (
          <div className={styles.row}>
            <dt>{t('label.close')}</dt>
            <dd>{event.close}</dd>
          </div>
        ) : null}
        <div className={`${styles.row} ${styles.span2}`}>
          <dt>{t('label.address')}</dt>
          <dd>
            {venue.address} · {venue.city}
          </dd>
        </div>
        <div className={`${styles.row} ${styles.span2}`}>
          <dt>{t('label.coords')}</dt>
          <dd className={styles.num}>{venue.coords}</dd>
        </div>
        {stages > 0 ? (
          <div className={styles.row}>
            <dt>STAGES</dt>
            <dd className={styles.num}>
              {String(stages).padStart(2, '0')} · {stageKeys.join(' / ')}
            </dd>
          </div>
        ) : null}
        {archived ? null : (
          <div className={styles.row}>
            <dt>AGE</dt>
            <dd>18 + · ID REQUIRED</dd>
          </div>
        )}
      </dl>
    </section>
  );
}
